import React from "react";

interface ListProps {
  items: string[];
  ordered?: boolean;
  className?: string;
  itemClassName?: string;
  renderItem?: (item: string, index: number) => React.ReactNode;
  variant?: "default" | "bullet" | "numbered";
  isFirstNone?: boolean;
}

export const List: React.FC<ListProps> = ({
  items,
  ordered = false,
  className = "",
  itemClassName = "",
  renderItem,
  variant = "default",
  isFirstNone = false,
}) => {
  const ListTag = ordered ? "ol" : "ul";

  const getListClass = () => {
    switch (variant) {
      case "bullet":
        return "list-disc";
      case "numbered":
        return "list-decimal";
      default:
        return "list-none";
    }
  };

  return (
    <ListTag className={`${getListClass()} pl-5 space-y-1 ${className}`.trim()}>
      {items.map((item, index) => (
        <li key={index} className={`${itemClassName} ${isFirstNone && index === 0 ? "list-none" : ""}`.trim()}>
          {renderItem ? renderItem(item, index) : item}
        </li>
      ))}
    </ListTag>
  );
};

export default List;
